/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2021-01-25 14:01:55
 */
import React, { Component } from 'react';
import { HotKeys } from 'react-hotkeys';
import { btnKeyMap } from './config/btnKeyboardMap';

function NcBackBtnWithKeyboardChange(WrappedComponent) {
    return class NcBackBtnWithHotKey extends Component {
        render() {
            let { onClick } = this.props;
            return (
                <HotKeys
                    keyMap={btnKeyMap}
                    handlers={{
                        shiftEsc: (e) => {
                            e.preventDefault();
                            if (onClick && typeof onClick === 'function') {
                                setTimeout(() => {
                                    onClick();
                                }, 300);
                            }
                        }
                    }}
                    attach={document.body}
                    focused={true}
                    style={{ display: 'inline-block' }}
                    className={"back-btn-hotkey-wrapper"}
                >
                    <WrappedComponent {...this.props} />
                </HotKeys>
            );
        }
    };
}

export default NcBackBtnWithKeyboardChange;
